import PageContainer from '@/common/components/PageContainer'
import EditBankAccountListing from '@/modules/bank/components/EditBankAccount/components/EditBankAccountListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function UpdateBankAccountPage() {
	return (
		<PageContainer>
			<EditBankAccountListing />
		</PageContainer>
	)
}

const GuardedUpdateBankAccountPage = withUserPermission(UpdateBankAccountPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_BANK_ACCOUNT],
})

export default GuardedUpdateBankAccountPage
